import { Input, Tag } from "@maeiz/ui";
import { Search } from "lucide-react";
import { DocPage, Section, Demo, SpecTable } from "../../components/DocChrome";

export function SearchPatternPage() {
    return (
        <DocPage
            title="Search & Filter"
            description="Reusable interaction model for list pages across panels."
        >
            <Section title="How it looks">
                <Demo className="space-y-3">
                    <Input
                        leftIcon={<Search size={16} />}
                        placeholder="Search customers…"
                        fullWidth
                    />
                    <div className="flex flex-wrap gap-2">
                        <Tag onRemove={() => undefined}>Area: Gulshan</Tag>
                        <Tag onRemove={() => undefined}>Status: Active</Tag>
                    </div>
                </Demo>
            </Section>
            <Section title="Rules">
                <SpecTable
                    rows={[
                        ["Page search", "Debounced q param; keep filters in URL when possible"],
                        ["Active filters", "Chips with clear-all"],
                        ["Empty filtered", "EmptyState: No results — clear filters"],
                        ["Global search", "Owner/Tenant command-style later; not required for MVP"],
                    ]}
                />
            </Section>
        </DocPage>
    );
}
